export const WIDGET_GRID_COPY = Object.freeze({
  errors: {
    generic: 'Something went wrong. Please try again.',
    dashboardLoad: 'Error loading dashboard.',
    connectionIssue: 'Connection issue',
    connectionMessage:
      "This content couldn't be retrieved due to a network issue. Please try again.",
    systemError: 'System error',
    systemErrorMessage:
      "We couldn't process your request at the moment. Please retry.",
    somethingWentWrong: 'Something went wrong',
    unexpectedError:
      'An unexpected error occurred while loading this content. Please try again.',
  },
  states: {
    loadingDashboard: 'Loading dashboard...',
    noWidgets: 'No widgets configured.',
    noData: 'No data to display.',
    noActivityYet: 'No activity yet',
    noActivityMessage:
      'New interactions and updates will appear here automatically.',
    noNotesYet: 'No notes yet',
    noNotesMessage: 'Add notes to track preferences or key info.',
  },
  actions: {
    retry: 'Retry',
    reload: 'Reload',
    create: 'Create',
    pin: 'Pin',
    info: 'Info',
    update: 'Update',
    expand: 'Expand',
    createNote: 'Create Note',
    options: 'Options',
    dragWidget: 'Drag widget',
    pinWidget: 'Mark as lock for users (cannot be removed by collaborators)',
    unpinWidget: 'Unlock widget for collaborators',
    removeWidget: 'Remove widget',
  },
});

const copy = WIDGET_GRID_COPY;

export const DEFAULT_STATE_COPY = Object.freeze({
  CONNECTION_ERROR: {
    icon: 'autorenew',
    title: copy.errors.connectionIssue,
    message: copy.errors.connectionMessage,
    buttonText: copy.actions.reload,
  },
  SYSTEM_ERROR: {
    icon: 'error',
    title: 'Error',
    message: copy.errors.generic,
    buttonText: copy.actions.retry,
  },
  EMPTY: {
    icon: 'inbox',
    title: 'No data',
    message: copy.states.noData,
    showButton: false,
  },
});

export const ACTIVITY_STATE_COPY = Object.freeze({
  CONNECTION_ERROR: {
    icon: 'autorenew',
    title: copy.errors.connectionIssue,
    message: copy.errors.connectionMessage,
    buttonText: copy.actions.reload,
  },
  SYSTEM_ERROR: {
    icon: 'error',
    title: copy.errors.systemError,
    message: copy.errors.systemErrorMessage,
    buttonText: copy.actions.retry,
  },
  EMPTY: {
    icon: 'lastUpdated',
    title: copy.states.noActivityYet,
    message: copy.states.noActivityMessage,
    showButton: false,
  },
});

export const NOTES_STATE_COPY = Object.freeze({
  CONNECTION_ERROR: {
    icon: 'autorenew',
    title: copy.errors.connectionIssue,
    message: copy.errors.connectionMessage,
    buttonText: copy.actions.reload,
  },
  SYSTEM_ERROR: {
    icon: 'error',
    title: copy.errors.somethingWentWrong,
    message: copy.errors.unexpectedError,
    buttonText: copy.actions.retry,
  },
  EMPTY: {
    icon: 'note_add',
    title: copy.states.noNotesYet,
    message: copy.states.noNotesMessage,
    buttonText: copy.actions.create,
    showButton: true,
  },
});
